import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'fr_CA',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '475a1747-05db-4381-811c-086e10ac7839',
  ''
);
